module.exports = __webpack_public_path__ + "img/sala-cortada.2fd38141.png";